import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { AppErrorBoundary } from './layouts/route-error';
import { initSentry } from './lib/sentry';
import { queryClient } from './query-client';
import { buildRouter } from './routes';
import './globals.css';

// FIRST, before the router is built and before anything renders. An error
// thrown while the tree mounts is exactly the kind this exists to catch, and
// initialising after `createRoot` would miss it.
initSentry();

const router = buildRouter(queryClient);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppErrorBoundary>
        {/* Every screen reads its data with `useSuspenseQuery`, and there was
            no boundary for any of them. A screen whose data had not arrived
            suspended into nothing: React rendered null, `#root` held zero
            children, and the page was blank with a silent console. R-143. */}
        <Suspense
          fallback={
            <div className="mx-auto max-w-[720px] px-5 py-24 text-center text-muted">
              Loading...
            </div>
          }
        >
          <RouterProvider router={router} />
        </Suspense>
      </AppErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
);
